<app-loader *ngIf="loading"></app-loader>
<div [id]="containerId"></div>
<app-no-widget-data *ngIf="!hasData && !loading"></app-no-widget-data>
<div *ngIf="hasData && !loading" class="legend-row">
  <span class="legend-item"><span class="dot men"></span> Men</span>
  <span class="legend-item"><span class="dot women"></span> Women</span>
  <span class="legend-item"><span class="dot no-data"></span> No Data</span>
</div>